import React from 'react';

import './Chapters.scss';
//import photo1 from "../../assets/inline-textwrap1.png";
//edit url below or delete below if importing photo above.

function Chapter2() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">A NEW ARRAY for a New World</h3>

      <div>
        <p className="chapter__paragraph">
          The{' '}
          <a
            href="https://www.basf.com/global/en/media/news-releases/2022/09/p-22-342.html"
            rel="sponsored"
            target="_blank"
          >
            2022-2023 collection, titled NEW ARRAY,
          </a>{' '}
          is meant to reflect consumers' shifting values and desires in the face of rapid social
          change. BASF’s Coatings division conducted consumer research that looked beyond trends in
          the automotive industry and into the worlds of fashion, current events, technology and
          more. “We're thinking about what's going on in science, what's going on in medicine,
          etc.,” says Elizabeth Hoffman, Head of BASF Automotive Design for the Americas. “All of
          those things really play an important factor in design.”
        </p>
        <p className="chapter__paragraph">
          Hoffman says that NEW ARRAY was inspired by “liminal spaces” — like the transition between
          the past and the future or between the virtual and the physical. BASF research shows that
          across cultures and markets there is a sense of global uncertainty. But this isn’t
          necessarily a bad thing, explains Hoffman. “You could look at uncertainty as a cause of
          stress. But on the other hand, you could think of it as something optimistic and exciting.
          A new sort of experience, a new adventure into this seamless world that we're quickly
          moving toward.”
        </p>
        <p className="chapter__paragraph">
          NEW ARRAY represents this ethos. The forty-five shade collection — which features hues
          from pearlescent creams and browns, to vibrant pinks and deep purples, to jewel tone
          greens and blues — can be imagined like a rainbow that arches towards a glowing yet hazy
          horizon.
        </p>
        <p className="chapter__paragraph">
          Color trends connect to regional identity as well. “The vehicle is an extension of your
          identity, your home, yourself, your family, and your culture, especially in America where
          it's a melting pot of people,” says Hoffman. “Many choose a color to celebrate something,
          to create a feeling of differentiation…” In North America, for example, BASF believes that
          a renewed cultural interest in science, developing technology, and space travel has
          expressed itself as a consumer preference for darker, deeper, and more complex colors.
        </p>
      </div>
    </section>
  );
}

export default Chapter2;
